export default __webpack_public_path__ + "static/media/bs.ee4e71ce.png";